import type { NumberTrainLevel } from "./types";

export const NUMBER_TRAIN_LEVELS: readonly NumberTrainLevel[] = [
  {
    id: "math-number-train-1",
    domain: "math",
    activityType: "number-train",
    difficulty: 1,
    objectives: ["匹配三以内的数量"],
    title: "车厢找朋友",
    instruction: "星星已经跳上车头啦。数一数，帮它找到一样多的车厢。",
    promptAudio: "/audio/voice/math/number-train-1.ogg",
    assets: [],
    payload: {
      mode: "match",
      targetCount: 2,
      choices: [
        { id: "one", count: 1 },
        { id: "two", count: 2 },
        { id: "three", count: 3 }
      ],
      correctChoiceId: "two"
    }
  },
  {
    id: "math-number-train-2",
    domain: "math",
    activityType: "number-train",
    difficulty: 2,
    objectives: ["匹配五以内的数量"],
    title: "星星车票",
    instruction: "这张星星车票要上车。数一数，哪节车厢和它一样多？",
    promptAudio: "/audio/voice/math/number-train-2.ogg",
    assets: [],
    payload: {
      mode: "match",
      targetCount: 4,
      choices: [
        { id: "three", count: 3 },
        { id: "five", count: 5 },
        { id: "four", count: 4 }
      ],
      correctChoiceId: "four"
    }
  },
  {
    id: "math-number-train-3",
    domain: "math",
    activityType: "number-train",
    difficulty: 3,
    objectives: ["比较五以内数量的多少"],
    title: "哪节装得多",
    instruction: "三节车厢都装着星星。比一比，哪一节装得最多？",
    promptAudio: "/audio/voice/math/number-train-3.ogg",
    assets: [],
    payload: {
      mode: "compare",
      relation: "most",
      choices: [
        { id: "two", count: 2 },
        { id: "four", count: 4 },
        { id: "three", count: 3 }
      ],
      correctChoiceId: "four"
    }
  },
  {
    id: "math-number-train-4",
    domain: "math",
    activityType: "number-train",
    difficulty: 4,
    objectives: ["比较十以内数量的多少"],
    title: "轻轻的小车厢",
    instruction: "小火车想轻轻出发。比一比，哪节车厢里的星星最少？",
    promptAudio: "/audio/voice/math/number-train-4.ogg",
    assets: [],
    payload: {
      mode: "compare",
      relation: "fewest",
      choices: [
        { id: "six", count: 6 },
        { id: "eight", count: 8 },
        { id: "seven", count: 7 }
      ],
      correctChoiceId: "six"
    }
  },
  {
    id: "math-number-train-5",
    domain: "math",
    activityType: "number-train",
    difficulty: 5,
    objectives: ["匹配十以内的数量"],
    title: "七颗星到站",
    instruction: "七颗星星在站台上等车。数一数，帮它们找到一样多的车厢。",
    promptAudio: "/audio/voice/math/number-train-5.ogg",
    assets: [],
    payload: {
      mode: "match",
      targetCount: 7,
      choices: [
        { id: "nine", count: 9 },
        { id: "seven", count: 7 },
        { id: "eight", count: 8 }
      ],
      correctChoiceId: "seven"
    }
  },
  {
    id: "math-number-train-6",
    domain: "math",
    activityType: "number-train",
    difficulty: 6,
    objectives: ["熟练比较十以内的数量"],
    title: "满满的星星",
    instruction: "星星装得满满的。仔细比一比，哪节车厢装得最多？",
    promptAudio: "/audio/voice/math/number-train-6.ogg",
    assets: [],
    payload: {
      mode: "compare",
      relation: "most",
      choices: [
        { id: "six", count: 6 },
        { id: "nine", count: 9 },
        { id: "eight", count: 8 }
      ],
      correctChoiceId: "nine"
    }
  }
];
